export default {
    "data": {
        "imgList":[
            "https://s21.lgstatic.com/growth/activity/20210315/1615777479981.png",
            "https://s21.lgstatic.com/growth/activity/20210315/1615777489533.png",
            "https://s21.lgstatic.com/growth/activity/20210315/1615777501387.png",
            "https://s21.lgstatic.com/growth/activity/20210315/1615777514728.png",
            "https://s21.lgstatic.com/growth/activity/20210315/1615777691622.png",
            "https://s21.lgstatic.com/growth/activity/20210315/1615791706124.png" 
        ],
        "btnImgList":[
            "https://s21.lgstatic.com/growth/activity/20210315/1615790724609.png",
            "https://s21.lgstatic.com/growth/activity/20210315/1615790759918.png",
            "https://s21.lgstatic.com/growth/activity/20210315/1615790734614.png",
            "https://s21.lgstatic.com/growth/activity/20210315/1615790770028.png",
            "https://s21.lgstatic.com/growth/activity/20210315/1615791211250.png",
            "https://s21.lgstatic.com/growth/activity/20210315/1615790898988.png",
            "https://s21.lgstatic.com/growth/activity/20210315/1615790744409.png",
            "https://s21.lgstatic.com/growth/activity/20210315/1615790908278.png"
        ],
        "imgList1": [
            "https://s21.lgstatic.com/growth/activity/20210315/1615777625678.png",
            "https://s21.lgstatic.com/growth/activity/20210315/1615777637589.png",
            "https://s21.lgstatic.com/growth/activity/20210519/1621413109980.png" 
        ],
        "H5footerImg":"https://s21.lgstatic.com/growth/activity/20210510/1620628180950.png",
        "PCimgList":[
            "https://s21.lgstatic.com/growth/activity/20210316/1615880103600.png",
            "https://s21.lgstatic.com/growth/activity/20210316/1615880113036.png",
            "https://s21.lgstatic.com/growth/activity/20210316/1615880121301.png",
            "https://s21.lgstatic.com/growth/activity/20210316/1615880131070.png",
            "https://s21.lgstatic.com/growth/activity/20210316/1615880140679.png",
            "https://s21.lgstatic.com/growth/activity/20210316/1615880151277.png"
        ],
        "PCstageList":[
            "https://s21.lgstatic.com/growth/activity/20210316/1615880373856.png",
            "https://s21.lgstatic.com/growth/activity/20210413/1618295540311.png",
            "https://s21.lgstatic.com/growth/activity/20210316/1615880390994.png",
            "https://s21.lgstatic.com/growth/activity/20210316/1615880402098.png"
        ],
        "PCimgList1":[
            "https://s21.lgstatic.com/growth/activity/20210316/1615881669563.png",
            "https://s21.lgstatic.com/growth/activity/20210316/1615881678837.png",
            "https://s21.lgstatic.com/growth/activity/20210519/1621413058619.png"
        ],
        "PCfooterImg":"https://s20.lgstatic.com/growth/activity/20210510/1620627800554.png",
        "sortStageList":[
            {
                "title":"Python 基础",
                "detail":[
                    {
                        "title":"第1关",
                        "name":"迪士尼乐园畅游指南",
                        "desc":"Python介绍、print()函数"
                    },{
                        "title":"第2关",
                        "name":"玩具店零售计价器",
                        "desc":"变量、数据类型"
                    },{
                        "title":"第3关",
                        "name":"【实战演练】豆瓣热评词云图",
                        "desc":"选出你在追的热剧"
                    },{
                        "title":"第4关",
                        "name":"侦探事务所的接线员",
                        "desc":"条件判断、条件嵌套"
                    },{
                        "title":"第5关",
                        "name":"编写聚会小游戏",
                        "desc":"input()函数"
                    },{
                        "title":"第6关",
                        "name":"存不满的百宝箱",
                        "desc":"列表、元组、字典"
                    },{
                        "title":"第7关",
                        "name":"用计算机处理文本",
                        "desc":"字符串运算与方法"
                    },{
                        "title":"第8关",
                        "name":"【实战演练】房贷计算器",
                        "desc":"控制语句与高级特性综合应用"
                    },{
                        "title":"第9关",
                        "name":"重复的事代码做",
                        "desc":"for循环、while循环"
                    },{
                        "title":"第10关",
                        "name":"跳出循环",
                        "desc":"循环控制"
                    },{
                        "title":"第11关",
                        "name":"用编程思维看问题",
                        "desc":"打开编程思维"
                    },{
                        "title":"第12关",
                        "name":"【实战演练】打造你的对战游戏",
                        "desc":"Python基础综合应用"
                    },{
                        "title":"第13关",
                        "name":"烤鸭店自动化升级",
                        "desc":"函数"
                    },{
                        "title":"第14关",
                        "name":"计算机的达芬奇密码",
                        "desc":"编码、文件读写"
                    },{
                        "title":"第15关",
                        "name":"模块助你小白变高手",
                        "desc":"模块"
                    },{
                        "title":"第16关",
                        "name":"包治百病的胶囊",
                        "desc":"代码调试debug"
                    },{
                        "title":"第17关",
                        "name":"搭建游戏玩家资料库（上）",
                        "desc":"面向对象、类"
                    },{
                        "title":"第18关",
                        "name":"搭建游戏玩家资料库（下）",
                        "desc":"类的继承"
                    },{
                        "title":"第19关",
                        "name":"【实战演练】程序帮你叫外卖",
                        "desc":"函数与类综合练习"
                    },{
                        "title":"第20关",
                        "name":"【实战演练】群发节日祝福",
                        "desc":"【实战演练】群发节日祝福"
                    },{
                        "title":"第21关",
                        "name":"【毕业项目】个人求职助手",
                        "desc":"统计计算、Python综合应用"
                    },{
                        "title":"第22关",
                        "name":"下一步！",
                        "desc":"安装本地环境、下一步学习计划"
                    }
                ]
            },{
                "title":"Python 数据分析",
                "detail":[
                    {
                        "title":"第23关",
                        "name":"数据分析初探",
                        "desc":"什么是数据分析、NumPy使用"
                    },{
                        "title":"第24关",
                        "name":"数据分析进阶之数据结构",
                        "desc":"pandas库基本数据结构：DataFrame、Series"
                    },{
                        "title":"第25关",
                        "name":"全球最幸福国家",
                        "desc":"数据读写、筛选、排序"
                    },{
                        "title":"第26关",
                        "name":"寻找目标用户",
                        "desc":"数据集成（合并、追加、数据融合）"
                    },{
                        "title":"第27关",
                        "name":"信用卡欺诈数据清洗",
                        "desc":"缺失、重复、异常数据的处理"
                    },{
                        "title":"第28关",
                        "name":"【实战演练】麦当劳菜单营养成分探析",
                        "desc":"常用数据分析统计方法"
                    },{
                        "title":"第29关",
                        "name":"最安全航空公司排名",
                        "desc":"数据重塑、分组聚合、数据透视"
                    },{
                        "title":"第30关",
                        "name":"探寻世界料理的秘密",
                        "desc":"数据转换、分箱操作"
                    },{
                        "title":"第31关",
                        "name":"数据可视化之美",
                        "desc":"Seaborn 库的常见可视化场景应用"
                    },{
                        "title":"第32关",
                        "name":"中国五大城市PM2.5数据分析",
                        "desc":"Seaborn 可视化时间序列数据"
                    },{
                        "title":"第33关",
                        "name":"【实战演练】发现销售瓶颈",
                        "desc":"多变量数据可视化、相关性分析"
                    },{
                        "title":"第34关",
                        "name":"【毕业项目】通过数据选基金经理",
                        "desc":"数据分析综合应用"
                    },
                ]
            },{
                "title":"Python 办公自动化",
                "detail":[
                    {
                        "title":"第35关",
                        "name":"自动整理归类电脑文件",
                        "desc":"os模块、文件读写、解压缩"
                    },{
                        "title":"第36关",
                        "name":"搞定 Excel 自动化",
                        "desc":"Excel文件读取、读取工作表、单元格、切片操作"
                    },{
                        "title":"第37关",
                        "name":"自动更新每日数据表",
                        "desc":"Excel文件写入、操作工作表、修改数据"
                    },{
                        "title":"第38关",
                        "name":"批量美化Excel表",
                        "desc":"Excel格式设置（字体、行列宽度、合并单元格、图表绘制）"
                    },{
                        "title":"第39关",
                        "name":"实用Word文件操作",
                        "desc":"Word文件操作初级"
                    },{
                        "title":"第40关",
                        "name":"【实战演练】根据人员信息表自动生成邀请函",
                        "desc":"Word文件操作高级"
                    },{
                        "title":"第41关",
                        "name":"拿来就用，PDF自动化操作",
                        "desc":"PDF的批量读取、拆分、合并、压缩"
                    },{
                        "title":"第42关",
                        "name":"PDF高级处理工具",
                        "desc":"PDF加密解密、添加水印"
                    },{
                        "title":"第43关",
                        "name":"一键下载全部邮件附件",
                        "desc":"Email高级操作（附件）"
                    },{
                        "title":"第44关",
                        "name":"【毕业项目】工作报告自动生成与发送",
                        "desc":"Excel + PDF + Email"
                    },
                ]
            },{
                "title":"Python 爬虫",
                "detail":[
                    {
                        "title":"第45关",
                        "name":"大话网上冲浪",
                        "desc":"requests"
                    },{
                        "title":"第46关",
                        "name":"网站的真相",
                        "desc":"HTML标签和属性"
                    },{
                        "title":"第47关",
                        "name":"爬虫初体验",
                        "desc":"beautifulsoup解析"
                    },{
                        "title":"第48关",
                        "name":"【实战演练】租房买房哪里好？我用Python帮忙找",
                        "desc":"requests + bs 综合应用 爬取链家租房信息"
                    },{
                        "title":"第49关",
                        "name":"周杰伦的音乐",
                        "desc":"xhr、json、url查询字符串、定制请求头"
                    },{
                        "title":"第50关",
                        "name":"歌曲评论背后的小故事",
                        "desc":"url查询字符串和定制请求头"
                    },{
                        "title":"第51关",
                        "name":"落袋为安",
                        "desc":"csv和excel文件"
                    },{
                        "title":"第52关",
                        "name":"【毕业项目】追踪岗位招聘数据",
                        "desc":"cookie 及 综合练习"
                    }
                ]
            }
        ],
    }
}